import {Component} from 'react';

export abstract class HelpMessage extends Component<{}> {

}
